<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <form [formGroup]="updateForm" enctype="multipart/form-data">
      <div class="form-group">
        <label>نوع الصلاحيــــة</label>
        <input
          formControlName="type"
          [class.is-invalid]="type.invalid && type.touched"
          type="text"
          class="form-control"
        />
        <div *ngIf="type.errors && type.invalid && type.touched">
          <small class="text-danger" *ngIf="type.errors?.required">
            نوع الصلاحيـــة مطلوب
          </small>
        </div>
      </div>
      <button type="submit" class="update btn btn-success mt-2" (click)="update()">
        تعديـــل
      </button>
    </form>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
